import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, orderReturnHistoriesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, orderReturnHistoriesActions);

export default slice.reducer;
